"use client";

/**
 * NewForm design-system Label.
 *
 * Form-control label tuned to the DS — sans 13/600 with the same
 * micro-tracking as DS card titles. Wraps Radix Label so the
 * `htmlFor` ↔ `id` association behaves identically to the shadcn
 * primitive it replaces:
 *
 *   import { Label } from "@/components/ui/design-system/label";
 *
 *   <Label htmlFor="batch-objective">Batch objective</Label>
 *   <Textarea id="batch-objective" ... />
 */

import * as LabelPrimitive from "@radix-ui/react-label";
import * as React from "react";

import { cn } from "@/lib/utils";

const Label = React.forwardRef<
  React.ElementRef<typeof LabelPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof LabelPrimitive.Root>
>(({ className, ...props }, ref) => (
  <LabelPrimitive.Root
    ref={ref}
    className={cn(
      "block font-nf-ds-sans text-[13px] font-[600] tracking-[-0.005em] text-foreground leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70",
      className,
    )}
    {...props}
  />
));
Label.displayName = "Label";

export { Label };
